import React, { forwardRef } from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const PlugIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 10 16"
    fill="none"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 4L2 1.01042C2 0.74244 2.10536 0.485437 2.29289 0.295946C2.48043 0.106456 2.73478 0 3 0C3.26522 0 3.51957 0.106456 3.70711 0.295946C3.89464 0.485437 4 0.74244 4 1.01042L4 4H6V1.01042C6 0.74244 6.10536 0.485437 6.29289 0.295946C6.48043 0.106456 6.73478 0 7 0C7.26522 0 7.51957 0.106456 7.70711 0.295946C7.89464 0.485437 8 0.74244 8 1.01042V4H8.87146C9.16713 4.0018 9.45018 4.12261 9.65925 4.33625C9.86832 4.54989 9.98655 4.83913 9.98831 5.14125L9.98607 7.63375C10.0196 8.09177 10.0657 9.50083 9.16259 10.8544C8.69607 11.5387 8.07121 12.0947 7.34362 12.4727C6.89287 12.7053 6.43899 12.8468 6 12.9239V14.9896C6 15.2576 5.89464 15.5146 5.70711 15.7041C5.51957 15.8935 5.26522 16 5 16C4.73478 16 4.48043 15.8935 4.29289 15.7041C4.10536 15.5146 4 15.2576 4 14.9896V12.8923C3.30544 12.7596 2.80118 12.543 2.6432 12.4727C1.01186 11.6099 0.134021 10.1978 0 8.30176V5.14125C0.0017582 4.83913 0.119989 4.54989 0.329058 4.33625C0.538127 4.12261 0.821181 4.0018 1.11684 4H2ZM5.14288 11H5.07586C4.9149 10.9984 4.75557 10.9857 4.59952 10.9645C4.08557 10.8946 3.68365 10.7417 3.51719 10.6717C2.59209 10.1622 2.0993 9.41409 2 8.22533V6H7.98754L7.98607 7.63196L7.98601 7.70591L7.9914 7.77966C8.01363 8.08346 8.03122 8.94052 7.50436 9.73612C7.22323 10.1457 6.85124 10.4742 6.42398 10.6966C6.00773 10.9109 5.57041 10.9958 5.14288 11Z"
      fill="#183558"
    />
  </svg>
));

export default PlugIcon;
